<template>
  <el-row>
    <!-- Form Search -->
    <el-col :span="24" class="group-search">
      <el-form :model="search" label-position="left">
        <p class="title-search">Quản lý sở GD-ĐT</p>
        <el-row>
          <el-col :span="11">
            <el-form-item label="Mã" class="label-custom">
              <el-input
                  maxlength='8'
                  @keyup.enter.native="searchData()"
                  v-model="search.code"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="2">
            <el-form-item label="Tên sở GD-ĐT">
              <el-input
                  @keyup.enter.native="searchData()"
                  v-model="search.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="16" class="button-search">
              <el-form-item>
                <el-button @click="searchData()" type="primary" class="btn">Tìm</el-button>
              </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-col>
    <!-- Button Action -->
    <el-col class="list-button">
      <div class="pagination-size">
        <p>Số bản ghi trên trang: </p>
        <el-dropdown @command="handleSelected">
					<span class="el-dropdown-link">
						{{ search.limit }}
						<i class="el-icon-caret-bottom"></i>
					</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
                v-for="item in listPaginate"
                :key="item.key"
                :command="item.value"
            >{{ item.value }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div>
        <el-button type="success" class="btn" :disabled="hasPermissionOnScreen(PERMISSION_CREATE)" @click="gotoLink({name: 'doet.create'})"><span>Thêm Mới</span></el-button>
        <el-button type="danger" class="btn" @click="deleteAll()" disabled v-show="!this.multipleSelection.length">Xóa</el-button>
        <el-button type="danger" class="btn" @click="deleteAll()" v-show="this.multipleSelection.length" :disabled="hasPermissionOnScreen(PERMISSION_DELETE)">Xóa</el-button>
      </div>
    </el-col>

    <el-card>
      <el-table
          v-loading="loading"
          :data="dataTable"
          style="width: 100%"
          class="mt3"
          ref="datatable"
          @selection-change="handleSelectionChange">
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column property="code" label="Mã"></el-table-column>
        <el-table-column property="name" label="Tên sở GD-ĐT"></el-table-column>
        <el-table-column label="Tình trạng">
          <template slot-scope="scope">
            <el-switch
                @change="handleStatus(scope.row)"
                v-model="scope.row.status"
                active-color="#67C23A"
                inactive-color="#C0C4CC"
                :disabled="hasPermissionOnScreen(PERMISSION_UPDATE)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="right">
          <template slot-scope="scope">
            <el-button
                @click="handleEdit(scope.row)"
                type="info"
                icon="el-icon-edit"
                size="mini"
                circle
                :disabled="hasPermissionOnScreen(PERMISSION_UPDATE)"
            ></el-button>
            <el-button
                @click="delData(scope.row)"
                type="danger"
                icon="el-icon-delete"
                size="mini"
                circle
                :disabled="hasPermissionOnScreen(PERMISSION_DELETE)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <custom-el-pagination
        :length="data.total || 0"
        :paginateFrom="data.from || 1"
        :paginateTo="data.to || 25"
        :total="data.total || 0"
        :pageSize="data.per_page || 25"
        :page="data.current_page || 1"
        @handleCurrentChange="handleChangePage"
      ></custom-el-pagination>
    </el-card>
  </el-row>
</template>

<script>
import DoetRequest from "@/requests/DoetRequest";
import CONST from "@/config/const";
export default {
  name: "DoetManager",
  data() {
    return {
      loading: false,
      search: {
        name: "",
        code: "",
        limit: CONST.PAGINATION[0].value,
      },
      data: [],
      dataTable: [],
      sortParams: [],
      multipleSelection: [],
      listPaginate: CONST.PAGINATION,
    };
  },

  methods: {
    getData(params = '') {
      DoetRequest.getList(params)
          .then((res) => {
            this.data = res.data;
            this.dataTable = this.formatDatatable(res.data.data)
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    searchData() {
      this.loading = true;
      this.getData(this.search)
    },

    handleSelected(limit) {
      this.search.limit = limit
      this.search.page = 1
      this.searchData();
    },

    handleEdit(row) {
      this.$router.push({ name: "doet.edit", params: { id: row.id } });
    },

    handleChangePage(page) {
      this.loading = true;
      let param = { ...this.search, page: page };
      this.getData(param);
    },

    async delData(params) {
      let checkConfirm = await this.showConfirmMixin();
      if (checkConfirm) {
        DoetRequest.destroy(params.id).then(() => {
         this.showSuccess('Xóa thành công.')
          this.getData(this.search);
        }).catch(() => {
          this.showError('Lỗi khi xóa.');
        });
      }
    },

    async deleteAll() {
      let checkConfirm = await this.showConfirmMixin();
      if (checkConfirm) {
        DoetRequest.destroyAll(this.multipleSelection).then(() => {
          this.showSuccess('Xóa thành công.')
          this.getData(this.search);
        }).catch(() => {
          this.showError('Lỗi khi xóa.');
        });
      }
    },

    handleSelectionChange() {
      const multiData = this.$refs.datatable ? this.$refs.datatable.selection : '';
      this.multipleSelection = _.map(multiData, (data) => {
        return data.id;
      })
    },

    handleStatus(row) {
      DoetRequest.edit(row.id, row).then(() => {
        this.showSuccess('Thành công.');
        this.getData(this.search);
      })
    },

    formatDatatable(data)
    {
      return _.map(data, (item) => {
        item.status = item.status ? true : false;
        return item;
      })
    }
  },
  created() {
    this.loading = true;
    this.getData(this.search);
  },
};
</script>

<style lang="scss" scoped>
.button-group {
  margin-top: 30px;
  margin-bottom: 20px;
}
.doet-management {
  .btn-custom {
    width: 95px;
    height: 40px;
    &:first-child{
      margin-right: 10px;
    }
    &:last-child{
      margin-left: 10px;
    }
  }
  .form-custom {
    margin-top: 24px;
    padding: 17px;
    .custom-input {
      width: 382px;
      height: 39px;
    }
    .fl-right {
      float: right;
    }
  }
  .clear-both {
    clear: both;
  }
  .label-custom {
    /deep/.el-form-item__label {
      text-align: left !important;
    }
  }
}
</style>